import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  labelStyle,
  tooltip,
  stroke,
  lineXaxis,
  DownloadButton,
} from '../options';
import { convertTZ, getDatesRange } from '../utils';

import dict from '../../dictionary';
import trans from '../../translations.json';
import ReducedData from '../../reducedData.json';
import { Checkbox } from 'antd';
import '../buttonGroup/buttonGroup.scss';
import compareChartColours from '../compareChart/compareChart.scss';
import './bySourceAll.scss';

const chartColours = [
  compareChartColours.compareChartColour1,
  compareChartColours.compareChartColour2,
  compareChartColours.compareChartColour3,
  compareChartColours.compareChartColour4,
  compareChartColours.compareChartColour5,
];

const latestDate = Object.keys(
    ReducedData.dataSourceAll[dict.sourcesAll['CC']],
  )
    .sort((a, b) => new Date(a) - new Date(b))
    .pop(),
  dateRange = getDatesRange('2020-01-15', latestDate);

//console.log("dateRange", dateRange);

const sourcesToDisplay = [
  'Travel',
  'CC',
  'No known epi link',
  'OB',
  'Unspecified epi link',
];

class BySourceGraph extends Component {
  state = {
    ready: false,
    keys: Object.keys(dict.sourcesAll),
    selection: [...sourcesToDisplay],
    selectionColors: chartColours,
    series: [],
    selectionLimitReached: false,
    options: {},
  };

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selection !== prevState.selection ||
      this.props.selectedTab !== prevProps.selectedTab
    ) {
      this.setData();
    }
  }

  toggleSelection = (name) => {
    var selection = [...this.state.selection];
    //check if it's already selected
    var currentSelectionKey = selection.indexOf(name);
    var availColour = selection.indexOf(null);

    if (currentSelectionKey !== -1) {
      selection[currentSelectionKey] = null;
    } else if (availColour !== -1) {
      selection[availColour] = name;
    }

    const newSelectionColors = chartColours.filter(
      (color, ind) => selection[ind],
    );

    this.setState({
      selectionLimitReached:
        currentSelectionKey === -1 && availColour === -1,
      selection: selection,
      selectionColors: newSelectionColors,
    });
  };

  setData = () => {
    let show = Boolean(
      this.state.selection.reduce((sum, sel) => sum + sel),
    );
    var series = [...this.state.selection]
      .filter((item) => item)
      .map((name, z) => {
        var sourceName = dict.sourcesAll[name];
        //console.log(sourceName, ReducedData.dataSourceAll[sourceName]);
        var accum = 0;
        return {
          name: trans.bySource[name][this.props.lang],
          data: [...dateRange].map((date, x) => {
            const newDate = convertTZ(
              date + 'T00:00:00',
              'America/Toronto',
            ).getTime();
            var value =
                ReducedData.dataSourceAll[sourceName][
                  x !== 0 && dateRange[x - 1] + 'T00:00:00'
                ] || 0,
              result;

            // if (!value) {
            //   console.log("object", value, sourceName, date, newDate);
            // }

            // Combines 'unspecified epi link' and 'missing info' data for 'other' category
            if (sourceName === 'UNSPECIFIED EPI LINK') {
              value =
                (ReducedData.dataSourceAll[sourceName][
                  x !== 0 && dateRange[x - 1] && date + 'T00:00:00'
                ] || 0) +
                (ReducedData.dataSourceAll[
                  dict.sourcesAll['Missing Information']
                ][
                  x !== 0 && dateRange[x - 1] && date + 'T00:00:00'
                ] || 0);
            }

            accum = accum + value;

            switch (this.props.selectedTab) {
              case 'newCases':
                result = value;
                break;
              case 'totalCases':
                result = accum;
                break;
              default:
                break;
            }

            return [newDate, result];
          }),
        };
      });
    series.forEach((item) =>
      item.data.sort((a, b) => new Date(a[0]) - new Date(b[0])),
    );
    //console.log('series', series);

    this.setState({
      series: [...series],
      options: {
        // title: { text: "Summary of Cases in Ontario" },
        colors: this.state.selectionColors,
        markers: {
          size: 0,
          //colors: ["#4D4D4D", "#49A7A2"],
          strokeColors: '#fff',
          strokeWidth: 1,
          hover: {
            size: 9,
          },
        },
        stroke: stroke,
        legend: {
          show: false,
        },
        tooltip: tooltip,
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          type: 'line',
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: trans.bySource.yaxis[this.props.lang],
          },
          decimalsInFloat: 0,
          labels: {
            style: { ...labelStyle },
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
        xaxis: {
          ...lineXaxis(show),
        },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: {
                animations: {
                  enabled: false,
                  animateGradually: {
                    enabled: false,
                  },
                  dynamicAnimation: {
                    enabled: false,
                  },
                },
                offsetX: 10,
                height: '200px',
                toolbar: {
                  tools: {
                    zoomin: false,
                    zoomout: false,
                  },
                },
              },
              xaxis: {
                labels: {
                  hideOverlappingLabels: true,
                },
              },
              legend: {
                fontSize: '10px',
              },
              dataLabels: {
                enabled: false,
              },
            },
          },
        ],
        // fill: {
        //   opacity: [0.2, 1],
        // },
      },
      ready: true,
    });
  };

  render() {
    const CheckboxesNames = () =>
      this.state.keys
        // .sort((a, b) => a.shortName.localeCompare(b.shortName))
        .filter((item) => sourcesToDisplay.includes(item))
        .map((item, key) => {
          var selectionKey = this.state.selection.includes(item)
            ? `compare-chart-${this.state.selection.indexOf(item)}`
            : '';

          return (
            <Checkbox
              checked={this.state.selection.includes(item)}
              onClick={() => this.toggleSelection(item)}
              className={`${selectionKey}`}
              key={key}
            >
              {trans.bySource[item][this.props.lang]}
            </Checkbox>
          );
        });

    return (
      <div
        id="bySourceGraph"
        className="chart ontario-margin-top-16-! ontario-margin-bottom-8-! "
      >
        {this.state.ready ? (
          <>
            <CheckboxesNames />
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              height={400}
              aria-hidden="true"
            />
          </>
        ) : (
          ''
        )}
      </div>
    );
  }
}
export default BySourceGraph;
